
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { NextSeoProps } from 'next-seo';
import { GetStaticPropsContext } from 'next/types';
import { Page as MakeswiftPage, PageProps as MakeswiftPageProps } from '@makeswift/runtime/next';
import { SWRConfig } from 'swr';
import { PersonFeedDocument } from '@/generated/contentful';
import { client as contentful } from '@/lib/contentful/client';
import { serializeCacheKey } from '@/lib/contentful/utils';
import { getPageSnapshot } from '@/lib/makeswift/client';
import '@/lib/makeswift/components';
import { runtime } from '@/lib/makeswift/runtime';
import { getPageLanguageAlternatives } from '@/utils/makeswift/getPageLanguageAlternatives';
import { CompanyLeadersMeta } from '@/components/Contentful/entries/Company/CompanyLeadersMeta/CompanyLeadersMeta';
import { limit } from '@/components/Contentful/entries/Person/PersonFeed';
import { PreviewToast } from '@/components/PreviewToast';
type Props = MakeswiftPageProps & {
    fallback: {
        [key: string]: unknown;
    };
    preview: boolean;
    locale: Locale;
    languageAlternates: NextSeoProps['languageAlternates'];
};
export default function LeadersPage({ snapshot, fallback, preview, locale, languageAlternates }: Props) {
    return (<SWRConfig value={{ fallback }}>
			<PreviewToast preview={preview}/>
			<CompanyLeadersMeta locale={locale} languageAlternates={languageAlternates}>
				<MakeswiftPage snapshot={snapshot} runtime={runtime}/>
			</CompanyLeadersMeta>
		</SWRConfig>);
}
async function getStaticProps({ previewData, preview, locale }: GetStaticPropsContext<{
    slug: string;
}, {
    makeswift: boolean;
}>) {
    const snapshot = await getPageSnapshot({
        pathname: '/company/leaders',
        previewData,
        isMakeswiftPreview: previewData?.makeswift == true,
        locale,
        timeout: {
            ms: 10000,
            message: `Timeout request getPageSnapshot for "/company/leaders" – Locale: ${locale}`
        }
    });
    if (snapshot == null) {
        return { notFound: true, revalidate: 3600 };
    }
    const languageAlternates = await getPageLanguageAlternatives({
        path: '/company/leaders',
        locale,
        previewData
    });
    return {
        props: {
            snapshot,
            previewData: previewData?.makeswift == true,
            preview: Boolean(preview),
            locale: locale as Locale,
            languageAlternates,
            fallback: {
                [serializeCacheKey('personFeed', { type: 'Leader', limit, skip: 0, locale })]: await contentful().request(PersonFeedDocument, {
                    where: { type: 'Leader', enabled: true },
                    limit,
                    skip: 0,
                    locale
                }),
                [serializeCacheKey('personFeed', { type: 'Advisor', limit, skip: 0, locale })]: await contentful().request(PersonFeedDocument, {
                    where: { type: 'Advisor', enabled: true },
                    limit,
                    skip: 0,
                    locale
                })
            },
            pageId: snapshot.document.id
        },
        revalidate: 3600
    };
}

    async function __Next_Translate__getStaticProps__1934a36ec5d__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/company/leaders/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1934a36ec5d__ as getStaticProps }
  